import { useWarehouseLabels } from '../warehouseLabels';

/**
 * Rótulos do REPACK (M7).
 *
 * ⚠️ Sem dicionário próprio, de propósito: as 140 chaves do M7 vivem em
 * `warehouseLabels.js`, com as do resto do módulo. O console e o coletor falam
 * do MESMO saldo, e dois vocabulários paralelos divergem no primeiro texto que
 * alguém ajusta só de um lado (CLAUDE.md §4).
 */
export function useRepackLabels() {
    return useWarehouseLabels();
}
